import { getRemoteConfigByKey } from '@/feature/analytics/hooks/use-firebase-remote-config';
import { FirebaseRemoteSettings } from '@/feature/analytics/utils/firebaseSettings';

// It is intended for A/B testing to determine whether to display the Date of Birth (DOB) first in the KYC flow.
// https://pitchtech.atlassian.net/browse/CSP-887
export const isDobFirstAB = (): boolean => getRemoteConfigByKey(FirebaseRemoteSettings.KYC_DOB_FIRST).asBoolean();
